var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCasualMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.589,
    height: 6.801,
    viewBox: "0 0 7.589 6.801",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shirt_curved",
    transform: "translate(-23.75 -31.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83758",
    "data-name": "Path 83758",
    d: "M24,33.181,25.181,32h1.181a1.181,1.181,0,0,0,2.363,0h1.181l1.181,1.181-.166,1.66a.2.2,0,0,1-.3.149l-.718-.431v2.954a.788.788,0,0,1-.788.788h-3.15a.788.788,0,0,1-.788-.788V34.56l-.718.431a.2.2,0,0,1-.3-.149Z",
    transform: "translate(0)",
    fill: "none",
    stroke: "#c014ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasualMessageIcon);
export default __webpack_public_path__ + "static/media/casual-message-icon.5e1adfdab24faf53ff9685fbd6660121.svg";
export { ForwardRef as ReactComponent };